<div class="container-fluid navBarInvoice">
  <app-header-form
    [title]="title"
    [panelOpenState]="panelOpenState"
    [canShowClearFilter]="true"
    [canShowPanelFilter]="true"
    [canExportExcel]="true"
    (onClearFilterEvent)="onClearFilters()"
    (onPanelOpenStateEvent)="onShowFilter($event)"
    (onExportAsExcelEvent)="exportAsExcel()"
    >
  </app-header-form>
</div>

<hr *ngIf="!panelOpenState">

<div class="container-fluid search-container">
  <div class="card" *ngIf="panelOpenState">
    <div class="card-body searchCard">
      <div fxLayout="row" fxLayoutGap="10px" >
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start">
          <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
            <mat-label>Retard<i>(en jours)</i></mat-label>
            <input matInput autocomplete="off" type="number" (change)="inputChanged($event.target.value)" (keyup)="inputChanged($event.target.value)"
            ng-min="1" ng-step="1" [ngModel]="delay">
          </mat-form-field>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start" >
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Situation travaux</mat-label>
              <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownList" (onDeSelect)="onItemSelect()"
                (onSelect)="onItemSelect()" placeholder='Sélectionner...' (onDeSelectAll)="onSelectAll($event, 'workingSituation')"
                (onSelectAll)="onSelectAll($event,'workingSituation')" [(ngModel)]="workingSituationSelectedItems" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="column" fxFlex="20" fxLayoutAlign="start" >
          <div fxLayout="row" class="dropDownStyle">
            <mat-form-field floatLabel="always" appearance="outline" fxFlex="100">
              <input matInput type="text" hidden>
              <mat-label>Reverse factoring</mat-label>
              <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="dropdownList" (onSelect)="onItemSelect()"
                (onDeSelect)="onItemSelect()" placeholder='Sélectionner...' (onSelectAll)="onSelectAll($event,'reverseFactoring')"
                (onDeSelectAll)="onSelectAll($event, 'reverseFactoring')" [(ngModel)]="reverseFactoringSelectedItems" class="search-dropdown">
              </ng-multiselect-dropdown>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-invoice-list [(data)]="invoicesGroups" [tableRowsActions]="tableActions" [canDownload]="false"
  [onClearFilters]="onClearFilters" [exportFileName]="exportFileName" [configKey]="configKeyGrps"
  [highlights]="highlightedGroup" [showClearFilterButton]="true" ngDefaultControl>
</app-invoice-list>

<div *ngIf="highlightedGroup && highlightedGroup.length">
  <app-invoice-list [(data)]="invoices" [canDownload]="false" [configKey]="configKeyInvoices" ngDefaultControl
  [exportFileName]="getDetailLateInvoiceExportFileName" [showClearFilterButton]="true">
  </app-invoice-list>
</div>
